import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useAppSelector } from "appRedux/hooks"
import { updateUserWishLists } from "appRedux/slices/userSlice"
import { useLazyGetWishListsQuery, wishListApi } from "appRedux/slices/wishListApiSlice"

export default function useWishLists() {
  const cachedUserWishLists = useAppSelector((state) => wishListApi.endpoints.getWishLists.select(undefined)(state))

  const [triggerGetWishLists, getWishListsResult] = useLazyGetWishListsQuery()

  const dispatch = useDispatch()

  useEffect(() => {
    if (cachedUserWishLists?.data) {
      dispatch(updateUserWishLists(cachedUserWishLists.data))
      return
    }
    fetchWishLists()
  }, [])

  function fetchWishLists() {
    triggerGetWishLists()
  }

  return {
    wishlists: cachedUserWishLists?.data || [],
    isFetching: getWishListsResult.isFetching,
    isError: getWishListsResult.isError
  }
}
